<template>
  <div class="container">
    <v-alert dense type="info" color="#3c1c64" prominent dismissible >
      <center>
      Suivez notre <u><a href="https://www.youtube.com/watch?v=6umacuo9Zec" target="_blank">tutoriel</a></u> de 15 minutes pour apprendre à utiliser notre outil.
      </center>
    </v-alert>
    <iframe
      width="100%"
      height="100%"
      src="https://share.mindmanager.com/#publish/Cns3-OeDLrcIwoN2U17vIm8fcZLtXBewTCYEirIv"
      />
  </div>
</template>

<script>
  export default {
    name: 'France 2030',
  }
</script>

<style lang="scss">
.container {
  // background-image: url('background-data.jpg');
  background-position: center center;
  background-size: cover;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .texthome {
    margin-top: 50px;
    margin-left: 50px;
    margin-right: 50px;
    text-align: center;
  }
}
</style>
